var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEditLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586a1.99 1.99 0 0 0-1.414-.586c-.534 0-1.036.208-1.413.585L4 13.585V18h4.413zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16zm-2 4h16v2H4z"
})));
export default SvgEditLine;